export class User {

    userPkid: number = 0;
    companyPkid?: number;
    locationPkid?: number;
    firstName: string = "Guest";
    phoneNumber: string = "1111111111";
    dialCode: string = "60";
    pax = 0;

    //loyalty

    lastName: string = "";
    loyalty_tier: string = "";
    points: number = 0;
    originPoints = 0;
    amount = 0;
    selectedLanguage: string = "en";

    minimum_order = 0;
    maximum_redemtion = 0;
    amountUnit = 0;
    pointsPerUnit = 0;

    earnPointTaxMode = "";

    programCurrency = "";

    maxUses = 0;
    minOrderAmountForPoints = 0;

    ratio: number = 0;

    month: number;
    next_tier: string;
    spend_more: number;
    constructor(data?: Partial<User>) {
        Object.assign(this, data);
    }

}